import FEATURE_FLAG_DEFAULTS from "./defaults.json";

export { FEATURE_FLAG_DEFAULTS };

export type TFeatureFlags = typeof FEATURE_FLAG_DEFAULTS;
export type FeatureFlag = keyof TFeatureFlags;

const FEATURE_FLAGS = Object.keys(FEATURE_FLAG_DEFAULTS);
export const isFeatureFlag = (key: string): key is FeatureFlag =>
  FEATURE_FLAGS.includes(key);
